import { useMemo } from "react";
import { VisitOutcome, outcomeSide } from "../models/VisitOutcome";
import { SessionVisits } from "../visits-slice";

export interface AttendanceCounts {
  present: number;
  absent: number;
  unmarked: number;
}

/** Present / absent / unmarked counts of the attendance draft, for the panel's summary line. */
export function useAttendanceCounts(memberIds: string[], outcomes: SessionVisits): AttendanceCounts {
  return useMemo(() => {
    const counts: AttendanceCounts = { present: 0, absent: 0, unmarked: 0 };
    for (const id of memberIds) {
      counts[outcomeSide(outcomes[id] ?? VisitOutcome.Unmarked)]++;
    }
    return counts;
  }, [memberIds, outcomes]);
}
